import Http from "../network/Http";
import moment from "moment";
import {
  isEmptyOrNull,
  isNotEmptyOrNull,
  tutorString,
  urlString,
} from "../utils/common-utils";
import { clearAllCookies, getCookie, setCookie } from "../utils/TutorConstants";
import { StorageService } from "../utils/StorageUtils";

const ENDPOINTS = {
  sendOTP: "/authentication/auth/v1/login",
  validateOTP: "/authentication/auth/verify",
  userDetails: "/schoolai/student/",
  waitlistedUsers: "/waitlisted-users",
  validateUser: "/authentication/auth/v2/login-password",
  forgotPassword: "/authentication/auth/v2/init-forgot-password",
  resetPassword: "/authentication/auth/v2/reset-password",
  logout: "/authentication/auth/logout",
  reports: "/reports",
  demoRunKafka: "/schoolai/kafka-event/publish",
};

export const sendOTP = async (countryCode, mobileNumber, isStandaloneUser) => {
  let data = {
    phoneNumber: `${countryCode}${mobileNumber}`,
    waitlist_enabled: true,
    standalone: isStandaloneUser,
  };
  const response = await Http.post(ENDPOINTS.sendOTP, JSON.stringify(data));
  return response;
};

export const sendWaitListUserDetails = async (grade, name) => {
  let data = {
    grade: grade,
    firstName: name,
  };
  const response = await Http.patch(
    ENDPOINTS.waitlistedUsers,
    JSON.stringify(data)
  );
  return response;
};

export const getUserDetails = async (userId, registrationStatus) => {
  try {
    let res = await Http.get(
      ENDPOINTS.userDetails +
        userId +
        `?registrationStatus=${registrationStatus}`
    );
    return res;
  } catch (e) {
    console.log(e);
  }
};

export const postKakfaEventForDemoRun = async (data) => {
  try {
    let res = await Http.post(ENDPOINTS.demoRunKafka, data);
    return res;
  } catch (e) {
    console.log(e);
  }
};

export const validateOtp = async (userName, session, code) => {
  let data = {
    userName: userName,
    code,
    session: session,
  };
  try {
    const response = await Http.post(
      ENDPOINTS.validateOTP,
      JSON.stringify(data)
    );

    return response;
  } catch (e) {
    console.log(e);
  }
};
export const validateUser = async (payload) => {
  try {
    const response = await Http.post(ENDPOINTS.validateUser, payload);

    return response;
  } catch (e) {
    console.log(e);
  }
};
export const forgotPassword = async (payload) => {
  try {
    const response = await Http.post(ENDPOINTS.forgotPassword, payload);

    return response;
  } catch (e) {
    console.log(e);
  }
};
export const resetPassword = async (payload) => {
  try {
    const response = await Http.post(ENDPOINTS.resetPassword, payload);

    return response;
  } catch (e) {
    console.log(e);
  }
};

export const logoutUser = async () => {
  try {
    const response = await Http.post(ENDPOINTS.logout);

    return response;
  } catch (e) {
    console.log(e);
  }
};
export const getSchoolDetails = async (schoolName) => {
  try {
    const response = await Http.get(
      `/schoolai/school/school-by-key?schoolKey=${schoolName}`
    );
    StorageService.setItem("sentryAllowed",response?.data?.data?.sentryAllowed);
    return response;
  } catch (e) {
    console.log(e);
  }
};
const getRefreshToken = async () => {
  const response = await Http.get("/global-auth/v1/student/refresh-token");
  return response;
};

export const redirectToLoginPage = async () => {
  let isTutor = StorageService?.getItem("isTutor");
  let details = StorageService?.getItem("user_additional_details");
  details = typeof details === "object" ? details : JSON.parse(details);
  if (isNotEmptyOrNull(getCookie("schoolName"))) {
    StorageService.clear();
    window.location.replace(`${urlString}/student/${getCookie("schoolName")}`);
  } else {
    if (getCookie("IsDemo")) {
      if (isNotEmptyOrNull(details?._id)) {
        let userData = await getUserDetails(
          details?._id,
          details?.registrationStatus
        );
        StorageService.setItem(
          "user_additional_details",
          JSON.stringify(userData?.data?.data)
        );
      }
    } else {
      StorageService.clear();
      clearAllCookies();
      window.location.replace(`${isTutor ? tutorString : urlString}/login`);
    }
  }
};

export const reportIssue = async () => {
  try {
    const apiData = StorageService.getItem("apiData");
    // const reportObject = {};
    // reportObject.lastFiveAPIResponses = JSON.stringify(apiData);
    const response = await Http.post(ENDPOINTS.reports, apiData);
    return response;
  } catch (error) {
    console.error("Some error", error);
    return "error";
  }
};

export const getAuthToken = async (getNewAuthToken) => {
  let userDetails = StorageService.getItem("user_details");
  try {
    userDetails =
      typeof userDetails === "object" ? userDetails : JSON.parse(userDetails);
    if (isNotEmptyOrNull(userDetails)) {
      const currentDate = new Date();
      const expirationDate = new Date(
        userDetails?.tokenExpire ?? userDetails?.expiresIn
      );
      let isExpired = currentDate > expirationDate;
      if (!isExpired && !getNewAuthToken) {
        return userDetails?.accessToken ?? userDetails?.idToken;
      } else if (
        (userDetails?.accessToken ?? userDetails?.idToken) &&
        userDetails?.refreshToken
      ) {
        try {
          let { success, data } = await getRefreshToken();
          const expiresIn = data?.data?.expiresIn;
          const idToken = data?.data?.idToken;
          if (success) {
            let expireInMin = (expiresIn || 0) / 60;
            expireInMin -= 2;
            const newDateObj = moment(new Date())
              .add(expireInMin, "m")
              .toString();
            userDetails.accessToken = idToken;
            userDetails.tokenExpire = newDateObj;
            StorageService.setItem("user_details", JSON.stringify(userDetails));
            return idToken;
          } else {
            redirectToLoginPage();
            return "";
          }
        } catch (error) {
          redirectToLoginPage();
          return userDetails?.accessToken;
        }
      }
    } else {
      return "";
    }
  } catch (e) {
    return "";
  }
  return "";
};
